import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Sidemenu from '../base/sidemenu';
import { fetchSevList } from "../../services/userApiServicer";
import DaumPostcode from 'react-daum-postcode';
import useDaumPostcode from "../../hooks/useDaumPostcode"

export default function UserWrite() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const defaultFamily = [{ name: "", phone: "", relation: "", birth: "" }];
  const familyListFromState = location.state?.familyList && location.state.familyList.length > 0
    ? location.state.familyList
    : defaultFamily;
  const [familyList, setFamilyList] = useState(familyListFromState);

  // location.state로 전달된 데이터 (뒤로가기 시 전달됨)
  const userData = location.state?.userData || {};

  // 상태 초기값을 location.state에서 받거나 빈값으로 초기화
  const [name, setName] = useState(userData.name || "");
  const [birth, setBirth] = useState(userData.birth || "");
  const [sex, setSex] = useState(userData.sex || "");
  const [phone, setPhone] = useState(userData.phone || "");
  const [address, setAddress] = useState(userData.address || "");
  const [pec, setPec] = useState(userData.pec || "");
  const [sevList, setSevList] = useState([]);
  const [departmentId, setdepartmentId] = useState(userData.department_id ? [userData.department_id] : [""]);

  const [departmentList, setDepartmentList] = useState([]);
  const [selectedSevId, setSelectedSevId] = useState(userData.sev_id || "");
  const [username, setUsername] = useState(userData.username || "");
  const [password, setPassword] = useState(userData.password || "");
  const [passwordConfirm, setPasswordConfirm] = useState(userData.password || ""); // 뒤로갈 때 비밀번호도 맞춰서 세팅
  const [detail_address, setDetailAddress] = useState(userData.detail_address || "");

  const today = new Date().toISOString().split('T')[0]



  const formatPhoneNumber = (value) => {
    const onlyNumber = value.replace(/\D/g, ''); // 숫자만 남김

    if (onlyNumber.length < 4) return onlyNumber;
    if (onlyNumber.length < 7) return onlyNumber.replace(/(\d{3})(\d+)/, '$1-$2');
    if (onlyNumber.length < 11) return onlyNumber.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
    return onlyNumber.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3');
  };

  const {
    isOpen,
    setIsOpen,
    handleComplete,
    popupRef
  } = useDaumPostcode(setAddress);

  useEffect(() => {
    const getSevList = async () => {
      try {
        const data = await fetchSevList(token);
        if (data.success === false) {
          alert(data.message);
          console.log("사용자등록 api호출완료");
          return;
        }
        setSevList(data.severity);
      } catch (error) {
        console.error("서비스 목록 불러오기 실패:", error);
      }
    };
    
    const fetchDepartmentList = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/department`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const result = await response.json();
        if (result.success !== false) {
          setDepartmentList(result.department); // API 응답 구조에 따라 조정
        } else {
          console.error("부서 목록 불러오기 실패:", result.message);
        }
      } catch (error) {
        console.error("부서 목록 불러오기 오류:", error);
      }
    };

    getSevList();
    fetchDepartmentList();
  }, [token]);

  const handleNext = () => {
    if (password !== passwordConfirm) {
      alert("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (!address && detail_address) {
      alert("주소를 입력하지 않고 상세주소만 입력할 수 없습니다.");
      return;
    }

    if (!name || !birth || !sex || !phone || !username || !password || !selectedSevId ) {
      alert("모든 항목을 입력해주세요. 단, 지병 항목은 필수 입력 사항이 아닙니다.");
      return;
    }

    if (!departmentId || departmentId.length === 0 || departmentId.includes("")) {
      alert("담당 관리소속을 선택해주세요.");
      return;
      }

      if (!selectedSevId) {
      alert("위험군 등급을 선택해주세요.");
      return;
    }
    navigate("/user/new/family", {
      state: {
        userData: {
          name,
          birth,
          sex,
          phone,
          address,
          detail_address,
          pec,
          sev_id: selectedSevId,
          username,
          department_id: departmentId,
          password,
        },
        familyList,
      },
    });
  };

  // 담당관리 추가
const addDepartment = () => {
  setdepartmentId([...departmentId, ""]);
};

// 담당관리 삭제
const removeDepartment = (index) => {
  if (departmentId.length > 1) {
    setdepartmentId(departmentId.filter((_, i) => i !== index));
  }
};

// 선택 변경
const handleDepartmentChange = (index, value) => {
  const updated = [...departmentId];
  updated[index] = value;
  setdepartmentId(updated);
};

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="user">
        <h1>사용자 관리</h1>
        <div className="user_box">
          <h2 className="subpage_title"><span className="before"><span className="nametit">사용자 등록</span></span></h2>
          <div className='user_writebox'>
            <div className='table02'>
              <table>
                <caption>사용자 등록 표</caption>
                <colgroup>
                  <col width="20%" />
                  <col width="80%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope='row'>이름</th>
                    <td><input type="text" placeholder='사용자의 이름을 입력하세요.' value={name} onChange={e => setName(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>생년월일</th>
                    <td><input type="date" className='date' max={today} value={birth} onChange={e => setBirth(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>성별</th>
                    <td>
                      <input type="radio" name="sex" id="man" value="male" checked={sex === "male"} onChange={e => setSex(e.target.value)} />
                      <label htmlFor="man">남성</label>
                      <input type="radio" name="sex" id="woman" value="female" checked={sex === "female"} onChange={e => setSex(e.target.value)} />
                      <label htmlFor="woman">여성</label>
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>전화번호</th>
                    <td><input type="text" placeholder='사용자의 전화번호를 입력하세요.' value={phone} onChange={e => { const formatted = formatPhoneNumber(e.target.value); if (formatted.length <= 13) { setPhone(formatted); } }} /></td>
                  </tr>
                  <tr>
                    <th scope="row">주소</th>
                    <td style={{ position: 'relative' }}>
                      <input
                        type="text"
                        placeholder="사용자의 주소를 입력하세요."
                        value={address}
                        readOnly
                        onClick={() => setIsOpen(true)}
                      />
                      {isOpen && (
                        <div
                          ref={popupRef}
                          style={{
                            position: 'absolute',
                            zIndex: 100,
                            border: '1px solid #ccc',
                            backgroundColor: '#fff',
                          }}
                        >
                          <DaumPostcode onComplete={handleComplete} />
                        </div>
                      )}
                      <br />
                      <input
                        type="text"
                        placeholder="상세 주소를 입력하세요."
                        value={detail_address}
                        onChange={(e) => setDetailAddress(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>담당관리</th>
                    <td>
                    {departmentId.map((id, index) => (
                      <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                        <select
                          value={id}
                          onChange={e => handleDepartmentChange(index, e.target.value)}
                        >
                          <option value="" disabled>담당 관리소속을 선택하세요.</option>
                          {Array.isArray(departmentList) && departmentList.map(department => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                          ))}
                        </select>
                        {departmentId.length > 1 && (
                          <button type="button" onClick={() => removeDepartment(index)} style={{ marginLeft: '8px' }}>삭제</button>
                        )}
                      </div>
                    ))}
                    <button type="button" onClick={addDepartment} style={{ padding: '2px 5px', marginTop: '5px', backgroundColor: '#007BFF', color: '#fff', border: 'none', borderRadius: '4px' }}>+ 추가</button>
                  </td>
                  </tr>
                  <tr>
                    <th scope='row'>지병</th>
                    <td><input type="text" placeholder='사용자의 지병을 입력하세요.' value={pec} onChange={e => setPec(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>위험군 등급</th>
                    <td>
                      <select value={selectedSevId} onChange={e => setSelectedSevId(e.target.value)}>
                        <option value="" disabled>위험군 등급을 선택하세요.</option>
                        {Array.isArray(sevList) && sevList.map(sev => (
                          <option key={sev.id} value={sev.id}>{sev.name}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  
                  <tr>
                    <th scope='row'>아이디</th>
                    <td><input type="text" placeholder='사용자가 사용할 아이디를 입력하세요.' value={username} onChange={e => setUsername(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>비밀번호</th>
                    <td><input type="password" placeholder='사용자가 사용할 비밀번호를 입력하세요.' value={password} onChange={e => setPassword(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>비밀번호 확인</th>
                    <td><input type="password" placeholder='비밀번호를 다시 입력하세요.' value={passwordConfirm} onChange={e => setPasswordConfirm(e.target.value)} /></td>
                  </tr>
                </tbody>
              </table>
            </div>
            
          </div>
          <div className="btn-group">
              <button className="btncolor02" onClick={() => navigate("/user")}>뒤로</button>
              <button className="btncolor01" onClick={handleNext}>다음</button>
          </div>
        </div>
      </div>
    </div>
  );
}
